import 'sbf-design-system-component/forms/base';
import 'sbf-design-system/js/lib/parsley';
import banner from 'sbf-design-system-component/banners/banner';
import '../application';

$(document).ready(function () {
  // Page load.
  handlePageHash();

  // Hash change event. (to account for forward and backward buttons)
  $(window).on('hashchange', function (e) {
    handlePageHash();
  });

  // ul.cancer-type-selector <a> click event.
  $('ul.cancer-type-selector a').unbind('click').bind('click', function (event) {
    event.preventDefault();
    const selector = `.${$(this).attr('class').replace(/selected/i, '').replace(/\s+/, '')}`;
    select(selector, true, true);
  });

  // select.cancer-type-selector change event.
  $('select.cancer-type-selector').unbind('change').bind('change', function (event) {
    event.preventDefault();
    const selector = `.${$(this).find(':selected').attr('class').replace(/selected/i, '').replace(/\s+/, '')}`;
    select(selector, true, true);
  });

  // Description link click event. (hash values only)
  $('#cancer-descriptions a[href^="#"]').on('click', function (event) {
    event.preventDefault();
    const selector = $(this).attr('href').replace('#', '.');
    select(selector, true, true);
  });

  // Registration form submit event.
  $('#registration-form').submit(function () {
    if (!validateForm()) {
      return false;
    }
    $.ajax({
      url: '/ajax/email/process-signup',
      type: 'POST',
      data: {
        email_address: $('#email-address').val(),
        first_name: $('#first-name').val(),
        address: $('#address').val()
      },
      complete: function (e) {
        if (e) {
          const data = $.parseJSON(e.responseText);
          if (data) {
            if (data.success) {
              $('#registration-form').hide();
              $('.section-sign-me-up__thanks').show();
            } else {
              banner.showError(data.error.message, true, 4000);
            }
          }
        }
      }
    });
    return false;
  });
});

/**
 * Validate registration form fields.
 *
 * @return boolean
 */
const validateForm = () => {
  let returnValue = true;
  $('#registration-form').find('.inline-input').find('[required]').each(function () {
    const $this = $(this);
    if (!$this.parsley().isValid(true)) {
      banner.showError($this.attr('data-parsley-error-message'), true, 4000);
      if (!window.navigator.userAgent.match(/iPhone/i)) {
        $this.focus();
      }
      $this.addClass('field--invalid');
      returnValue = false;
      return false;
    }
  });
  return returnValue;
};

/**
 * Handle cancer type selections.
 *
 * @return none
 */
const select = (selector, animate, modifyPageHash) => {
  const $ulSelector = $('ul.cancer-type-selector');
  const $optionSelector = $('select.cancer-type-selector');
  const $descriptions = $('#cancer-descriptions');
  const $imageStage = $('.section-closer-look #cancer-images');
  const slideWidth = $imageStage.width();
  const slideSpeed = 400;

  // Clear ul.cancer-type-selector selection.
  $ulSelector.find('.selected').removeClass('selected');
  // Select current ul.cancer-type-selector item.
  $ulSelector.find(selector).addClass('selected');
  // Clear select.cancer-type-selector selection.
  $optionSelector.find('option:selected').removeAttr('selected');
  // Select current select.cancer-type-selector item.
  $optionSelector.find(selector).attr('selected', 'selected');
  // Hide previous description text.
  $descriptions.find('p').addClass('hide');
  // Show current description text.
  $descriptions.find(selector).removeClass('hide');
  // Update page URL hash value.
  if (modifyPageHash) {
    if (selector === '.all') {
      window.history.pushState('', '', `${location.pathname}${location.search}`);
    } else {
      window.location.hash = selector.replace(/^\./, '#');
    }
  }
  // Show current image.
  const index = $optionSelector[0].selectedIndex;
  if (animate) {
    // Current x position in pixels.
    const position = parseInt($imageStage.css('backgroundPosition').split(/\s/)[0]);
    // Slide out.
    $imageStage.animate({ 'background-position-x': `${position + slideWidth}px` }, slideSpeed, () => {
      // Set new position to slide in from.
      $imageStage.css('backgroundPosition', `${(index * -440)}px 0px`);
      // Slide in.
      $imageStage.delay(slideSpeed)
        .animate({ 'background-position-x': `${(index * -440) - slideWidth}px` }, slideSpeed);
    });
  } else {
    // No slide, just set position. (good for page load)
    $imageStage.css('backgroundPosition', `${((index * -440) - slideWidth)}px 0px`);
  }
};

/**
 * Handle selections based on hash values.
 *
 * @return none
 */
const handlePageHash = () => {
  const pageHash = window.location.hash;
  if (pageHash !== '') {
    select(pageHash.replace('#', '.'), false);
  } else {
    select('.all', false);
  }
};
